var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyTagListDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.513,
    height: 100,
    viewBox: "0 0 98.513 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tags",
    transform: "translate(-7.5 0.002)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8694",
    "data-name": "Rectangle 8694",
    width: 37.661,
    height: 56.095,
    rx: 10,
    transform: "translate(7.5 43.903)",
    fill: "#b3aed1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23425",
    "data-name": "Path 23425",
    d: "M146.42,221.5H137.5a2.973,2.973,0,0,1,2.973,2.973v50.148a2.973,2.973,0,0,1-2.973,2.973h8.92a2.973,2.973,0,0,0,2.973-2.973V224.473A2.973,2.973,0,0,0,146.42,221.5Z",
    transform: "translate(-104.232 -177.597)",
    fill: "#9892bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23426",
    "data-name": "Path 23426",
    d: "M73.873,381.973H59.021a1.487,1.487,0,0,1,0-2.973H73.873a1.487,1.487,0,1,1,0,2.973Zm0,8.92H59.021a1.487,1.487,0,0,1,0-2.973H73.873a1.487,1.487,0,0,1,0,2.973Z",
    transform: "translate(-40.116 -303.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23427",
    "data-name": "Path 23427",
    d: "M98.063,152.449a1.488,1.488,0,0,1-1.4-1.988,37.13,37.13,0,0,0,.367-24.127,1.487,1.487,0,0,1,2.827-.921,40.1,40.1,0,0,1-.4,26.05A1.487,1.487,0,0,1,98.063,152.449Z",
    transform: "translate(-71.42 -99.733)",
    fill: "#8b8893"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4050",
    "data-name": "Ellipse 4050",
    cx: 4.361,
    cy: 4.361,
    r: 4.361,
    transform: "translate(21.97 49.85)",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23428",
    "data-name": "Path 23428",
    d: "M96.487,251.5a4.351,4.351,0,0,0-1.487.26,4.362,4.362,0,0,1,0,8.2,4.361,4.361,0,1,0,1.487-8.461Z",
    transform: "translate(-70.156 -201.65)",
    fill: "#6a5fa2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4051",
    "data-name": "Ellipse 4051",
    cx: 22.497,
    cy: 22.497,
    r: 22.497,
    transform: "translate(61.018 19.324)",
    fill: "#b3aed1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23429",
    "data-name": "Path 23429",
    d: "M372.96,97.5a22.6,22.6,0,0,0-4.46.443,22.5,22.5,0,0,1,0,44.109A22.5,22.5,0,1,0,372.96,97.5Z",
    transform: "translate(-289.444 -78.176)",
    fill: "#9892bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23430",
    "data-name": "Path 23430",
    d: "M383.536,27.733a1.488,1.488,0,0,1-1.4-1.979,36.95,36.95,0,0,0,.277-23.807,1.487,1.487,0,1,1,2.826-.923,39.921,39.921,0,0,1-.3,25.715,1.487,1.487,0,0,1-1.4.994Z",
    transform: "translate(-300.308)",
    fill: "#8b8893"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4052",
    "data-name": "Ellipse 4052",
    cx: 4.361,
    cy: 4.361,
    r: 4.361,
    transform: "translate(79.155 25.271)",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23431",
    "data-name": "Path 23431",
    d: "M384.987,127.5a4.352,4.352,0,0,0-1.487.26,4.362,4.362,0,0,1,0,8.2,4.361,4.361,0,1,0,1.487-8.461Z",
    transform: "translate(-301.471 -102.229)",
    fill: "#6a5fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23432",
    "data-name": "Path 23432",
    d: "M208.356,193.821l-29.3,9.245a2.973,2.973,0,0,1-3.73-1.941l-14.384-45.587a2.973,2.973,0,0,1,.141-2.151L166.86,141a2.973,2.973,0,0,1,1.8-1.579l11.683-3.686a2.973,2.973,0,0,1,2.38.26l11.84,6.83a2.973,2.973,0,0,1,1.35,1.681L210.3,190.091a2.973,2.973,0,0,1-1.941,3.73Z",
    transform: "translate(-122.917 -108.72)",
    fill: "#877fb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23433",
    "data-name": "Path 23433",
    d: "M265.94,190.091,251.556,144.5a2.973,2.973,0,0,0-1.35-1.681l-11.84-6.83a2.973,2.973,0,0,0-2.38-.26l-1.187.374,6.488,3.742a2.973,2.973,0,0,1,1.35,1.681l14.384,45.587a2.973,2.973,0,0,1-1.941,3.73L230.2,198.7l.766,2.428a2.973,2.973,0,0,0,3.73,1.941l29.3-9.245a2.973,2.973,0,0,0,1.941-3.73Z",
    transform: "translate(-178.561 -108.72)",
    fill: "#746ba8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23434",
    "data-name": "Path 23434",
    d: "M254.42,315.449a1.487,1.487,0,0,1-.447-2.9l11.682-3.686a1.487,1.487,0,1,1,.895,2.835l-11.683,3.686A1.485,1.485,0,0,1,254.42,315.449Zm2.973,8.92a1.487,1.487,0,0,1-.447-2.9l11.682-3.686a1.487,1.487,0,1,1,.895,2.835L257.841,324.3A1.483,1.483,0,0,1,257.393,324.368Z",
    transform: "translate(-196.785 -247.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23435",
    "data-name": "Path 23435",
    d: "M204.582,80.632h-.051a1.487,1.487,0,0,1-1.436-1.536A35.487,35.487,0,0,0,196.356,57a1.487,1.487,0,1,1,2.408-1.744,38.458,38.458,0,0,1,7.3,23.936A1.487,1.487,0,0,1,204.582,80.632Z",
    transform: "translate(-151.195 -43.815)",
    fill: "#8b8893"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4053",
    "data-name": "Ellipse 4053",
    cx: 4.361,
    cy: 4.361,
    r: 4.361,
    transform: "translate(50.324 34.325)",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23436",
    "data-name": "Path 23436",
    d: "M243.7,176.223a4.361,4.361,0,0,0-5.471-2.847c-.059.019-.117.039-.174.06a4.36,4.36,0,0,1,0,8.2,4.36,4.36,0,0,0,5.645-5.411Z",
    transform: "translate(-184.851 -138.85)",
    fill: "#6a5fa2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTagListDark);
export default __webpack_public_path__ + "static/media/empty_tag_list_dark.a416d45373fb3beb762c021187f041cd.svg";
export { ForwardRef as ReactComponent };